import { useState, useEffect } from 'react';
import { Card, Row, Col, Space, Typography, Spin } from 'antd';
import Data from '../../../CustomText/data';
import { convertCentsIntoDollar, formatDate } from '../../../../helpers/genericHelper';
import moment from 'moment';
import API from '../../../../services/API';

export default function PaymentIssues({ userId }) {
  const [paymentIssues, setPaymentIssues] = useState({ achPaymentIssues: [], stripeDeclines: [] });
  const [paymentIssuesLoaded, setPaymentIssuesLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const achIssues = paymentIssues?.achPaymentIssues;
  const stripeDeclines = paymentIssues?.stripeDeclines;
  const hasAchIssues = achIssues && achIssues.length > 0;
  const hasStripeDeclines = stripeDeclines && stripeDeclines.length > 0;

  const getPaymentIssues = async () => {
    if (paymentIssuesLoaded) return;
    setLoading(true);
    try {
      const issues = await API.getSubscriptionPaymentIssues(userId);
      setPaymentIssues(issues || { achPaymentIssues: [], stripeDeclines: [] });
    } finally {
      setLoading(false);
      setPaymentIssuesLoaded(true);
    }
  }

  useEffect(() => {
    setPaymentIssuesLoaded(false);
    getPaymentIssues();
  }, [userId]);

  return (
    <Spin spinning={loading} tip="Loading payment issues...">
      <Space direction="vertical" style={{ width: '100%', margin: '20px' }}>
        <Typography.Title level={5}>ACH Payment Issues</Typography.Title>
      {hasAchIssues ? (
        achIssues.map((issue, index) => (
          <Card
            key={`ach-${index}`}
            bordered={true}
            className="criclebox tablespace mb-16"
          >
            <Row gutter={[30, 30]}>
              <Col span={2}>
                <Data title="Return Code" value={issue?.returnCode} />
              </Col>
              <Col span={4}>
                <Data title="Status" value={issue?.status} />
              </Col>
              <Col span={2}>
                <Data title="Amount" value={issue?.amountCents ? convertCentsIntoDollar(issue?.amountCents) : null} />
              </Col>
              <Col span={4}>
                <Data title="ACH Start Time" value={issue?.achStartTime ? formatDate(moment(issue?.achStartTime).toDate(), true) : null} />
              </Col>
              <Col span={4}>
                <Data title="ACH Finish Time" value={issue?.achFinishTime ? formatDate(moment(issue?.achFinishTime).toDate(), true) : null} />
              </Col>
              <Col span={6}>
                <Data title="Provider Transaction ID" value={issue?.providerTransactionId} />
              </Col>
            </Row>
          </Card>
        ))
      ) : (
        <Typography.Text type="secondary">No ACH payment issues</Typography.Text>
      )}

      <Typography.Title level={5}>Stripe Declines</Typography.Title>
      {hasStripeDeclines ? (
        stripeDeclines.map((decline, index) => (
          <Card
            key={`stripe-${index}`}
            bordered={true}
            className="criclebox tablespace mb-16 card-cancel-subscription"
          >
            <Row gutter={[30, 30]}>
              <Col span={4}>
                <Data title="Decline Code" value={decline?.declineCode} />
              </Col>
              <Col span={6}>
                <Data title="Payment Intent ID" value={decline?.paymentIntentId} />
              </Col>
              <Col span={6}>
                <Data title="Invoice ID" value={decline?.invoiceId} />
              </Col>
              <Col span={4}>
                <Data title="Created" value={decline?.createTs ? formatDate(moment(decline?.createTs).toDate(), true) : null} />
              </Col>
            </Row>
          </Card>
        ))
      ) : (
        <Typography.Text type="secondary">No Stripe declines</Typography.Text>
      )}
      </Space>
    </Spin>
  );
}
